/** @format */
import {EyeIcon, EyeOffIcon} from '@heroicons/react/solid'
import React, {useContext, useState} from 'react'
import ActionInput from '../../components/tailwind/ActionInput'
import {AccountContext} from '../../contexts/AccountContext'
import {
  ModalContext,
  ContextModal
} from '../../components/tailwind/ModalContext'
import {LoadingContext} from '../../contexts/LoadingContext'
import Modal from '../../components/tailwind/Modal'
import LoaderButton from '../../components/tailwind/LoaderButton'

export default function ChangePasswordModal({modal}) {
  const {ready} = useContext(LoadingContext)
  const {patchAccount} = useContext(AccountContext)
  const {closeCurrentModal} = useContext(ModalContext)
  const [newPassword, setNewPassword] = useState('')
  const [oldPassword, setOldPassword] = useState('')
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)

  return (
    <ContextModal modal={modal} title={'Update Account Password'}>
      <ActionInput
        label={'Old Password'}
        value={oldPassword}
        type={showOldPassword ? 'text' : 'password'}
        onChange={e => {
          setOldPassword(e.target.value)
        }}
        suffix={
          <button
            className="block h-5 w-5 text-gray-300"
            onClick={() => setShowOldPassword(!showOldPassword)}
            type="button"
          >
            {showOldPassword ? <EyeOffIcon /> : <EyeIcon />}
          </button>
        }
      />
      <ActionInput
        label={'New Password'}
        value={newPassword}
        type={showNewPassword ? 'text' : 'password'}
        onChange={e => {
          e.preventDefault()
          setNewPassword(e.target.value)
        }}
        suffix={
          <button
            className="block h-5 w-5 text-gray-300"
            onClick={() => setShowNewPassword(!showNewPassword)}
            type="button"
          >
            {showNewPassword ? <EyeOffIcon /> : <EyeIcon />}
          </button>
        }
      />
      <Modal.Footer>
        <LoaderButton
          onClick={() => {
            patchAccount({
              payload: {
                password: newPassword,
                old_password: oldPassword
              },
              profile: true
            }).then(() => {
              closeCurrentModal()
              setOldPassword('')
              setNewPassword('')
              ready()
            })
          }}
          disabled={!newPassword || !oldPassword}
        >
          Save
        </LoaderButton>
      </Modal.Footer>
    </ContextModal>
  )
}
